module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai219-8a76e4e7608d04563642a3b20be2e665.jpg";